var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.95,
    height: 38.655,
    viewBox: "0 0 42.95 38.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M53.4,73.124V68.3A4.3,4.3,0,0,1,57.7,64H81.322a4.3,4.3,0,0,1,4.295,4.3V87.623a4.3,4.3,0,0,1-4.295,4.295H70.386a4.3,4.3,0,0,1-3.232-1.467l-12.687-14.5A4.3,4.3,0,0,1,53.4,73.124Zm8.59-1.071a1.611,1.611,0,0,0,0,3.221H77.027a1.611,1.611,0,1,0,0-3.221Zm4.832,10.2a1.611,1.611,0,0,1,1.611-1.611h8.59a1.611,1.611,0,0,1,0,3.221h-8.59A1.611,1.611,0,0,1,66.827,82.254ZM57.7,85.475a4.3,4.3,0,1,1-4.3-4.295A4.295,4.295,0,0,1,57.7,85.475ZM42.667,96.213a4.3,4.3,0,0,1,4.295-4.3h.368a4.3,4.3,0,0,1,3.037,1.258,4.3,4.3,0,0,0,6.074,0,4.3,4.3,0,0,1,3.037-1.258h.368a4.3,4.3,0,0,1,4.3,4.3V98.36a4.3,4.3,0,0,1-4.3,4.3H46.962a4.3,4.3,0,0,1-4.295-4.3Z",
    transform: "translate(-42.667 -64)",
    fill: "#212968",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForTeacher);
export default __webpack_public_path__ + "static/media/for-teacher.10d3fd04273f83fe8710e315bee66839.svg";
export { ForwardRef as ReactComponent };